import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';


export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const isAdmin = currentUser?.role === 'admin';
  const isMedicalBusiness = currentUser?.businessType === 'medical';

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const isCurrentPath = (path: string) => {
    return location.pathname === path;
  };

  return {
    handleNavigate,
    isCurrentPath,
    isAdmin,
    isMedicalBusiness,
    currentPath: location.pathname,
    currentUser
  };
};